<template>
	<b-form-group
		:label="`${label + asterisk}`"
		:label-for="`textarea-${name}-${_uid}`"
		:label-class="{
			'label-light-grey': true,
			'is-invalid': currentState == false,
		}">
		<b-form-textarea
			:id="`textarea-${name}-${_uid}`"
			:class="{ open: focused || isOpen }"
			:state="currentState"
			:required="required"
			:value="value"
			:rows="rows"
			:maxlength="maxlength"
			v-bind="$attrs"
			@focus="focused = true"
			@blur="focused = false"
			@input="handleInput"></b-form-textarea>
	</b-form-group>
</template>
<script>
export default {
	name: "TextAreaComponent",
	props: {
		name: String,
		label: String,
		required: Boolean,
		rows: {
			type: [String, Number],
			default: 3,
		},
		maxlength: {
			type: [String, Number],
			default: 65535,
		},
		value: String,
	},
	data() {
		return {
			focused: false,
		};
	},
	computed: {
		currentState() {
			if (!this.$parent?.$v?.[this.name]?.$dirty) {
				return null;
			}

			if (this.$parent.$v[this.name].$error && this.required) {
				return false;
			}

			if (!this.$parent.$v[this.name].$error) {
				return true;
			}

			return null;
		},
		asterisk() {
			return this.required ? "*" : "";
		},
		isOpen() {
			return this.value;
		},
	},
	methods: {
		setValue(newVal) {
			this.$emit("input", newVal);
			this.$parent.$v?.[this.name]?.$touch();
		},
		handleInput(newVal) {
			this.setValue(newVal);
		},
	},
	inheritAttrs: false,
};
</script>
<style lang="scss"></style>
